import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c179139c"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("Ajustes")
const _hoisted_2 = { class: "wrapper" }
const _hoisted_3 = { class: "keep-values" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Conservar valores nueva línea", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "section" }, "Datos obligatorios", -1))
const _hoisted_6 = { class: "permissions" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Lote", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Foto lote", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Adjunto 1", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Adjunto 2", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Adjunto 3", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Firma cliente", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Email cliente", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Escanear etiqueta", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Mayorista", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "section" }, "Opciones y utilidades", -1))
const _hoisted_17 = { class: "permissions" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Cuentas bancarias", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Gestión muestras", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Valorar devolución", -1))

import { IonContent, IonHeader, IonTitle, IonToolbar, IonButtons, IonToggle, modalController } from '@ionic/vue'

import { useAuthStore } from '@/store/auth'

import IonicIcon from '@/components/IonicIcon.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'SettingsView',
  setup(__props) {

const authStore = useAuthStore()

const cancel = () => modalController.dismiss(null, 'cancel')

const getPermissionIcon = (permission: boolean) => {
  return permission ? 'checkmarkCircleOutline' : 'ellipseOutline'
}

const getPermissionColor = (permission: boolean) => {
  return permission ? 'primary' : 'medium'
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(IonHeader), null, {
      default: _withCtx(() => [
        _createVNode(_unref(IonToolbar), null, {
          default: _withCtx(() => [
            _createVNode(_unref(IonButtons), { slot: "start" }, {
              default: _withCtx(() => [
                _createVNode(IonicIcon, {
                  icon: "arrowBackOutline",
                  onClick: cancel
                })
              ]),
              _: 1
            }),
            _createVNode(_unref(IonTitle), null, {
              default: _withCtx(() => [
                _hoisted_1
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_unref(IonContent), null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("div", null, [
              _createVNode(_unref(IonToggle), {
                modelValue: _unref(authStore).keepValuesFromPreviousLine,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(authStore).keepValuesFromPreviousLine) = $event))
              }, null, 8, ["modelValue"])
            ])
          ]),
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", null, [
              _hoisted_7,
              _createElementVNode("div", null, [
                _createVNode(IonicIcon, {
                  icon: getPermissionIcon(_unref(authStore).settings.requiredRefundFields.lotNumber),
                  color: getPermissionColor(_unref(authStore).settings.requiredRefundFields.lotNumber)
                }, null, 8, ["icon", "color"])
              ])
            ]),
            _createElementVNode("div", null, [
              _hoisted_8,
              _createElementVNode("div", null, [
                _createVNode(IonicIcon, {
                  icon: getPermissionIcon(_unref(authStore).settings.requiredRefundFields.lotImage),
                  color: getPermissionColor(_unref(authStore).settings.requiredRefundFields.lotImage)
                }, null, 8, ["icon", "color"])
              ])
            ]),
            _createElementVNode("div", null, [
              _hoisted_9,
              _createElementVNode("div", null, [
                _createVNode(IonicIcon, {
                  icon: getPermissionIcon(_unref(authStore).settings.requiredRefundFields.attachment1),
                  color: getPermissionColor(_unref(authStore).settings.requiredRefundFields.attachment1)
                }, null, 8, ["icon", "color"])
              ])
            ]),
            _createElementVNode("div", null, [
              _hoisted_10,
              _createElementVNode("div", null, [
                _createVNode(IonicIcon, {
                  icon: getPermissionIcon(_unref(authStore).settings.requiredRefundFields.attachment2),
                  color: getPermissionColor(_unref(authStore).settings.requiredRefundFields.attachment2)
                }, null, 8, ["icon", "color"])
              ])
            ]),
            _createElementVNode("div", null, [
              _hoisted_11,
              _createElementVNode("div", null, [
                _createVNode(IonicIcon, {
                  icon: getPermissionIcon(_unref(authStore).settings.requiredRefundFields.attachment3),
                  color: getPermissionColor(_unref(authStore).settings.requiredRefundFields.attachment3)
                }, null, 8, ["icon", "color"])
              ])
            ]),
            _createElementVNode("div", null, [
              _hoisted_12,
              _createElementVNode("div", null, [
                _createVNode(IonicIcon, {
                  icon: getPermissionIcon(_unref(authStore).settings.requiredRefundFields.signature),
                  color: getPermissionColor(_unref(authStore).settings.requiredRefundFields.signature)
                }, null, 8, ["icon", "color"])
              ])
            ]),
            _createElementVNode("div", null, [
              _hoisted_13,
              _createElementVNode("div", null, [
                _createVNode(IonicIcon, {
                  icon: getPermissionIcon(_unref(authStore).settings.requiredRefundFields.email),
                  color: getPermissionColor(_unref(authStore).settings.requiredRefundFields.email)
                }, null, 8, ["icon", "color"])
              ])
            ]),
            _createElementVNode("div", null, [
              _hoisted_14,
              _createElementVNode("div", null, [
                _createVNode(IonicIcon, {
                  icon: getPermissionIcon(_unref(authStore).user.virtualTag === 1),
                  color: getPermissionColor(_unref(authStore).user.virtualTag === 1)
                }, null, 8, ["icon", "color"])
              ])
            ]),
            _createElementVNode("div", null, [
              _hoisted_15,
              _createElementVNode("div", null, [
                _createVNode(IonicIcon, {
                  icon: getPermissionIcon(_unref(authStore).settings.requiredRefundFields.wholesaler),
                  color: getPermissionColor(_unref(authStore).settings.requiredRefundFields.wholesaler)
                }, null, 8, ["icon", "color"])
              ])
            ])
          ]),
          _hoisted_16,
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", null, [
              _hoisted_18,
              _createElementVNode("div", null, [
                _createVNode(IonicIcon, {
                  icon: getPermissionIcon(_unref(authStore).settings.permissions.bankAccounts),
                  color: getPermissionColor(_unref(authStore).settings.permissions.bankAccounts)
                }, null, 8, ["icon", "color"])
              ])
            ]),
            _createElementVNode("div", null, [
              _hoisted_19,
              _createElementVNode("div", null, [
                _createVNode(IonicIcon, {
                  icon: getPermissionIcon(_unref(authStore).settings.requiredSamplesFields.lotSamples),
                  color: getPermissionColor(_unref(authStore).settings.requiredSamplesFields.lotSamples)
                }, null, 8, ["icon", "color"])
              ])
            ]),
            _createElementVNode("div", null, [
              _hoisted_20,
              _createElementVNode("div", null, [
                _createVNode(IonicIcon, {
                  icon: getPermissionIcon(_unref(authStore).settings.permissions.reviewRefund),
                  color: getPermissionColor(_unref(authStore).settings.permissions.reviewRefund)
                }, null, 8, ["icon", "color"])
              ])
            ])
          ])
        ])
      ]),
      _: 1
    })
  ], 64))
}
}

})